import {
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useToast from "../../../../../../hooks/useToast";
import useConfirm from "../../../../../../hooks/useConfirm";
import { TYPE_NOTIFICATION } from "../../../../shares/NotificationBull";
import AppButton from "../../../../shares/AppButton";
import { SQCFormulaireService } from "../../../../../../service/SQC_form/SQCFormulaireService";
import StandardSkeletoon from "../../../../shares/loader/StandardSkeletoon";

const INIT_FORM_INFO = {
  id_type: "",
  categorie: "1",
  direction_antenne: "",
  region: "",
  district: "",
  commune: "",
  libele: "",
  zone: "",
  cadre_dirigeant: "0",
  superviseur: "0",
  informaticien_os: "0",
  nbr_chef_eqipe: "0",
  redacteur: "0",
  volontaires: "0",
};

const INIT_FORM_ERROR = {
  id_type_error: null,
  categorie_error: null,
  direction_antenne_error: null,
  region_error: null,
  district_error: null,
  commune_error: null,
  libele_error: null,
  zone_error: null,
  cadre_dirigeant_error: null,
  superviseur_error: null,
  informaticien_os_error: null,
  nbr_chef_eqipe_error: null,
  redacteur_error: null,
  volontaires_error: null,
};

const OPTION_CATEGORIE = [
  { label: "formulaire principale", value: "1" },
  { label: "formulaire secondraire", value: "2" },
];

const SQCDialogForm = ({ open, onFormClose, onFormOpen, idAmi, idForm }) => {
  const [formInfo, setFormInfo] = useState(INIT_FORM_INFO);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [submited, setSubmited] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const { Toast, showToast } = useToast();
  const navigate = useNavigate();
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const handleFormClose = () => {
    onFormClose();
    setFormInfo(INIT_FORM_INFO);
  };

  const handleChangeFormInfo = (e) => {
    const { name, value } = e.target;
    setFormInfo({ ...formInfo, [name]: value });
  };

  const handleFetchFormInfo = () => {
    setFormLoading(true);
    SQCFormulaireService.findOneById(idForm)
      .then((res) => {
        if (res && res.data) {
          setFormInfo(res.data);
        }
      })
      .then(() => {
        setFormLoading(false);
      });
  };

  const handleCheckDataValidation = () => {
    setFormErrors({
      libele_error: formInfo.libele ? null : "Titre est obligatoire",
      categorie_error: formInfo.categorie ? null : "Categorie est obligatoire",
      direction_antenne_error: null /*formInfo.direction_antenne
        ? null
        : "Direction est obligatoire",*/,
      region_error: null, // formInfo.region ? null : "Region est obligatoire",
      district_error: null, // formInfo.district ? null : "District est obligatoire",
      commune_error: null, // formInfo.commune ? null : "Commune est obligatoire",
      zone_error: null, // formInfo.zone ? null : "Zone est obligatoire",
      cadre_dirigeant_error: null, // formInfo.cadre_dirigeant
      // ? null
      // : "Cadre dirigeant est obligatoire",
      superviseur_error: null, // formInfo.superviseur
      // ? null
      // : "Superviseur est obligatoire",
      informaticien_os_error: null, // formInfo.informaticien_os
      // ? null
      // : "Informaticien est obligatoire",
      nbr_chef_eqipe_error: null, // formInfo.nbr_chef_eqipe
      // ? null
      // : "Nombre de chef d'équipe est obligatoire",
      redacteur_error: null, // formInfo.redacteur
      // ? null
      // : "Redacteur est obligatoire",
      volontaires_error: null, // formInfo.volontaires
      // ? null
      // : "Volontaires est obligatoire",
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleSave = () => {
    if (idForm) {
      handleUpdate();
    } else {
      handleInsert();
    }
  };
  const handleInsert = () => {
    setSubmited(true);
    setLoading(true);
    SQCFormulaireService.insert(formInfo)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmited(false);
        setLoading(false);
      });
  };

  const handleUpdate = () => {
    setSubmited(true);
    setLoading(true);
    SQCFormulaireService.update(formInfo)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmited(false);
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    setSubmited(true);
    if (handleCheckDataValidation()) {
      handleSave();
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  useEffect(() => {
    if (formInfo) {
      handleCheckDataValidation();
    }
  }, [formInfo]);

  useEffect(() => {
    setFormInfo({ ...formInfo, id_type: idAmi });
    if (idForm && open) {
      handleFetchFormInfo();
    }
  }, [idForm, open]);

  return (
    <>
      <DialogComponent />
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="sm">
        <Toast />
        <Paper sx={{ m: 3 }} elevation={0}>
          <Grid>
            <CardHeader
              title={idForm ? "Modifier formulaire" : "Creer formulaire"}
            />
            <CardContent>
              <Grid item width={"100%"} display={formLoading ? "" : "none"}>
                <StandardSkeletoon
                  show={formLoading}
                  row={4}
                  col={1}
                  escalier={true}
                  m={2}
                />
              </Grid>
              <Grid container display={formLoading ? "none" : ""}>
                {/* <Grid item /* md={6} > */}
                  {/* <CardHeader title={"Informations générales"} /> */}
                  <FormControl fullWidth>
                    <label>Titre</label>
                    <TextField
                      id="libele"
                      name="libele"
                      onChange={handleChangeFormInfo}
                      size="small"
                      value={formInfo.libele || ""}
                      error={formErrors.libele_error && submited}
                      helperText={submited ? formErrors.libele_error : ""}
                      placeholder="Titre"
                      fullWidth
                      aria-describedby="libele_helper"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Categorie</label>
                    <TextField
                      disabled
                      id="categorie"
                      name="categorie"
                      onChange={handleChangeFormInfo}
                      size="small"
                      value={formInfo.categorie || ""}
                      error={formErrors.categorie_error && submited}
                      helperText={submited ? formErrors.categorie_error : ""}
                      placeholder="categorie"
                      fullWidth
                      aria-describedby="categorie_helper"
                    />
                  </FormControl>
                 {/* <FormControl fullWidth>
                    <label>Zone</label>
                    <TextField
                      id="zone"
                      name="zone"
                      onChange={handleChangeFormInfo}
                      size="small"
                      value={formInfo.zone || ""}
                      error={formErrors.zone_error && submited}
                      helperText={submited ? formErrors.zone_error : ""}
                      placeholder="Zone"
                      fullWidth
                      aria-describedby="zone_helper"
                    />
                  </FormControl>
                   <FormControl fullWidth>
                    <label>Direction/Antenne</label>
                    <TextField
                      id="direction_antenne"
                      name="direction_antenne"
                      onChange={handleChangeFormInfo}
                      size="small"
                      value={formInfo.direction_antenne || ""}
                      error={formErrors.direction_antenne_error && submited}
                      helperText={
                        submited ? formErrors.direction_antenne_error : ""
                      }
                      placeholder="Direction/Antenne"
                      fullWidth
                      aria-describedby="direction_antenne_helper"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Région</label>
                    <TextField
                      id="region"
                      name="region"
                      onChange={handleChangeFormInfo}
                      size="small"
                      value={formInfo.region || ""}
                      error={formErrors.region_error && submited}
                      helperText={submited ? formErrors.region_error : ""}
                      placeholder="Région"
                      fullWidth
                      aria-describedby="region_helper"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <label>District</label>
                    <TextField
                      id="district"
                      name="district"
                      onChange={handleChangeFormInfo}
                      size="small"
                      value={formInfo.district || ""}
                      error={formErrors.district_error && submited}
                      helperText={submited ? formErrors.district_error : ""}
                      placeholder="District"
                      fullWidth
                      aria-describedby="district_helper"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Commmune</label>
                    <TextField
                      id="commune"
                      name="commune"
                      onChange={handleChangeFormInfo}
                      size="small"
                      value={formInfo.commune || ""}
                      error={formErrors.commune_error && submited}
                      helperText={submited ? formErrors.commune_error : ""}
                      placeholder="Commune"
                      fullWidth
                      aria-describedby="commune_helper"
                    />
                  </FormControl> */}
                {/* </Grid> */}
               {/*  <Grid item md={6} p={2} display={"none"}>
                  <CardHeader title={"Effectif personnels clés"} />
                  <FormControl fullWidth>
                    <label>Cadre dirigeant</label>
                    <TextField
                      id="cadre_dirigeant"
                      name="cadre_dirigeant"
                      type="number"
                      onChange={handleChangeFormInfo}
                      size="small"
                      value={formInfo.cadre_dirigeant || ""}
                      error={formErrors.cadre_dirigeant_error && submited}
                      helperText={
                        submited ? formErrors.cadre_dirigeant_error : ""
                      }
                      placeholder="Cadre dirigeant"
                      fullWidth
                      aria-describedby="cadre_dirigeant_helper"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Superviseur</label>
                    <TextField
                      id="superviseur"
                      name="superviseur"
                      onChange={handleChangeFormInfo}
                      size="small"
                      type="number"
                      value={formInfo.superviseur || ""}
                      error={formErrors.superviseur_error && submited}
                      helperText={submited ? formErrors.superviseur_error : ""}
                      placeholder="Superviseur"
                      fullWidth
                      aria-describedby="superviseur_helper"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Informaticien/OS</label>
                    <TextField
                      id="informaticien_os"
                      name="informaticien_os"
                      onChange={handleChangeFormInfo}
                      type="number"
                      size="small"
                      value={formInfo.informaticien_os || ""}
                      error={formErrors.informaticien_os_error && submited}
                      helperText={
                        submited ? formErrors.informaticien_os_error : ""
                      }
                      placeholder="Informaticien/OS"
                      fullWidth
                      aria-describedby="informaticien_os_helper"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Chef d'equipe</label>
                    <TextField
                      id="nbr_chef_eqipe"
                      name="nbr_chef_eqipe"
                      onChange={handleChangeFormInfo}
                      size="small"
                      type="number"
                      value={formInfo.nbr_chef_eqipe || ""}
                      error={formErrors.nbr_chef_eqipe_error && submited}
                      helperText={
                        submited ? formErrors.nbr_chef_eqipe_error : ""
                      }
                      placeholder="Nombre de chef d'equipe"
                      fullWidth
                      aria-describedby="nbr_chef_eqipe_helper"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Redacteur</label>
                    <TextField
                      id="redacteur"
                      name="redacteur"
                      onChange={handleChangeFormInfo}
                      type="number"
                      size="small"
                      value={formInfo.redacteur || ""}
                      error={formErrors.redacteur_error && submited}
                      helperText={submited ? formErrors.redacteur_error : ""}
                      placeholder="Redacteur"
                      fullWidth
                      aria-describedby="redacteur_helper"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Volontaires</label>
                    <TextField
                      id="volontaires"
                      name="volontaires"
                      onChange={handleChangeFormInfo}
                      size="small"
                      value={formInfo.volontaires || ""}
                      error={formErrors.volontaires_error && submited}
                      helperText={submited ? formErrors.volontaires_error : ""}
                      placeholder="Volontaires"
                      fullWidth
                      aria-describedby="volontaires_helper"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Total volontariat</label>
                    <TextField
                      size="small"
                      value={
                        Number(formInfo.cadre_dirigeant) +
                        Number(formInfo.superviseur) +
                        Number(formInfo.informaticien_os) +
                        Number(formInfo.nbr_chef_eqipe) +
                        Number(formInfo.redacteur) +
                        Number(formInfo.volontaires)
                      }
                      placeholder="Total volontaires"
                      fullWidth
                      aria-describedby="total_helper"
                    />
                  </FormControl>
                </Grid> */}
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                loading={loading}
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={(e) => handleSubmit()}
              />
              <AppButton
                text={"Fermer"}
                size={"medium"}
                variant={"outlined"}
                onClick={(e) => handleFormClose()}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default SQCDialogForm;
